import { Model } from "pinia-orm";

export default class Cadaster extends Model {
  static entity = "cadasters";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      plotNumber: this.attr(null),
      surface: this.attr(null),
      createdAt: this.string(""),
    };
  }
}
